'use client';

import posthog from 'posthog-js';
import Link from 'next/link';
import { useEffect } from 'react';
import { Logo } from '@puzzlio/ui';
import { Button } from '@puzzlio/ui';

// Webpack module resolution fails with this message when the client has stale
// JS chunks from a previous deployment and the server sends RSC payloads with
// new module IDs. A hard reload fetches the current chunks and self-heals.
function isChunkMismatchError(error: Error) {
  return (
    error?.message?.includes("Cannot read properties of undefined (reading 'call')") ||
    error?.name === 'ChunkLoadError' ||
    error?.message?.includes('Loading chunk')
  );
}

export default function ErrorPage({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    if (isChunkMismatchError(error)) {
      posthog.capture('chunk_mismatch_reload', { error_message: error.message });
      window.location.reload();
    } else {
      posthog.captureException(error);
    }
  }, [error]);
  return (
    <html>
      <body>
        <div className="min-h-screen">
          <main className="flex flex-col items-center gap-8">
            <div className="flex flex-col items-center gap-2 pt-7 sm:pt-16 lg:pt-20">
              <h1>
                <Link href="/" className="inline-flex items-center text-black hover:text-gray-700">
                  <Logo />
                </Link>
              </h1>
            </div>

            <div className="flex flex-col items-center gap-6 px-4 text-center">
              <h2 className="text-4xl font-bold">Something went wrong :(</h2>
              <p className="text-lg text-gray-600">Oops! Something went wrong. Please try again later.</p>
              <Link href="/">
                <Button variant="gameplay" color="red" size="gameplay">
                  Return Home
                </Button>
              </Link>
            </div>
          </main>
        </div>
      </body>
    </html>
  );
}
